<div class="card">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                <label class="form-check-label" for="ativo">Ativo</label>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="nome" pInputText formControlName="nome">
                    <label for="nome">Nome</label>
                </p-floatlabel>
            </div>




        </form>
        <h5>Estações</h5>
        <div class="field col-12 md:col-12 xl:col-12">
            <p-listbox [options]="dropDownEstacoes" [(ngModel)]="estacoesSelecionadas" [checkbox]="true" [filter]="true" filterLocale="pt-BR"
                [multiple]="true" optionLabel="label" [listStyle]="{'max-height':'250px'}">
            </p-listbox>

        </div>
        <!-- <p-tabView>
            <p-tabPanel header="Dados principais">
                <form [formGroup]="form" class="p-fluid grid">

                    <div class="field col-12 md:col-12 xl:col-12">
                        <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                        <label class="form-check-label" for="ativo">Ativo</label>
                    </div>

                    <div class="field col-12 md:col-12 xl:col-12">
                        <p-floatlabel>
                            <input type="text" id="nome" pInputText formControlName="nome">
                            <label for="nome">Nome</label>
                        </p-floatlabel>
                    </div>
                   

                </form>
            </p-tabPanel>
            <p-tabPanel header="Estações">
                <div *ngFor="let item of array_estacoes" class="p-fluid grid col-12">
                    <div class="p-fluid grid col-12">


                        <div class="field col-12 md:col-12 xl:col-4">
                            <p-floatlabel>
                                <p-dropdown inputId="estacao_id" appendTo="body" [filter]="true" filterLocale="pt-BR"
                                    [options]="dropDownEstacoes" [(ngModel)]="item.estacao_id">
                                </p-dropdown>
                                <label for="estacao_id">Estação</label>
                            </p-floatlabel>
                        </div>



                        <div class="col-12 md:col-12 xl:col-2">
                            <button pButton pRipple icon="pi pi-minus" (click)="removeEstacao(item)" label="Remover"
                                type="button" class="p-button-raised p-text-bold btn-lg p-button-danger"></button>
                        </div>

                        <div class="col-12 ">
                            <hr>
                        </div>

                    </div>
                </div>

                <div class="col-12 md:col-12 xl:col-4">
                    <button pButton pRipple icon="pi pi-plus" (click)="addEstacao()" label="Inserir estação"
                        type="button" class="p-button-raised p-text-bold btn-lg p-button-success"></button>
                </div>
            </p-tabPanel>
        </p-tabView> -->



    </div>

    <div class="footer">
        <div class="flex justify-content-end">
            <div class="mr-2">
                <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
                    label="Salvar" class="p-button-raised p-button-success"></button>
            </div>
        </div>

    </div>
</div>
